module.exports = __webpack_public_path__ + "img/icon_deepSleep.0c4f6603.png";